<template>
  <div class="wrapper" v-loading="loading">
    <div class="nohave" v-if="!ishave">
      <div class="info">
        <div class="image">
          <img src="../image/scan/waring.png" alt />
        </div>
        <div class="code">
          <p>{{ strAll }}</p>
          <div class="line"></div>
          <div class="tishi">{{ message }}</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="content-logo">
        <img src="../image/scan/new-banner.jpg" alt />
      </div>
      <div class="search-info common-box">
        <p class="search-num">此产品查询次数 {{ count }} 次</p>
        <p class="search-date">首次查询：{{ firstScanDate }}</p>
        <!-- <p class="search-company">您所查询的产品是由深圳芭田生态工程股份有限公司生产</p> -->
      </div>
      <div class="tracecode-box common-box">{{ strAll }}</div>
      <div class="content-details common-box">
        <ul>
          <li v-if="productName">
            <p class="li-label">产品名称：</p>
            <p class="li-name">{{ productName }}</p>
          </li>
          <li v-if="specifications">
            <p class="li-label">净含量：</p>
            <p class="li-name">{{ specifications }}</p>
          </li>
          <li class="test" v-if="edibleMethod">
            <p class="li-label">产品介绍：</p>
            <p class="li-name">{{ edibleMethod }}</p>
          </li>
          <li v-if="productImg" class="video">
            <p class="li-label">产品介绍视频：</p>
            <p class="li-name">
              <!-- <video ref="videoRef" controls style="object-fit:fill" webkit-playsinline="true" x-webkit-airplay="true"
                playsinline="true" x5-video-player-type="h5-page" x5-video-orientation="h5"
                x5-video-player-fullscreen="true" preload="auto" x5-playsinline="true">
                <source :src="productImg" type="video/mp4" />
              </video> -->
              <video-player class="video-palyer-box" ref="videoPlayer" :options="playerOptions"></video-player>
              <!-- <img :src="productVideoPoster" alt=""> -->
            </p>
          </li>
          <!-- <li>
            <p class="li-label">产品案例：</p>
            <p class="li-name">
              点击查看
            </p>
          </li> -->
        </ul>
      </div>
      <div class="content-details common-box">
        <ul>
          <!-- <li>
            <p class="li-label">产品名称：</p>
            <p class="li-name">{{ productName }}</p>
          </li>
          <li>
            <p class="li-label">净含量：</p>
            <p class="li-name">{{ specifications }}</p>
          </li> -->
          <!-- style="display: flex; flex-direction: column" -->
          <li class="flex-column">
            <!-- <li> -->
            <p class="li-label">产品合格证：</p>
            <div class="li-name">
              <!-- <span style="color: #c50000" @click="certView">点击查看</span> -->
              <div class="cert-box">
                <div class="cert-con">
                  <div class="cert-title">产品合格证</div>
                  <div class="cert-info">
                    <div class="cert-li">执行标准：详见外包装</div>
                    <div class="cert-li">检验结论：合格</div>
                    <div class="cert-li">生产日期/批号：{{ batchNum }}</div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <p class="li-label">生产企业：</p>
            <p class="li-name">见外包装</p>
          </li>
          <li>
            <p class="li-label">生产地址：</p>
            <p class="li-name">见外包装</p>
          </li>
          <li>
            <p class="li-label">网址：</p>
            <p class="li-name">见外包装</p>
          </li>
          <li>
            <p class="li-label">服务电话：</p>
            <p class="li-name">见外包装</p>
          </li>
        </ul>
      </div>
      <div class="content-details common-box">
        <div class="flow-name">流向信息</div>
        <ul>
          <li>
            <p class="li-label">经销商：</p>
            <p class="li-name">{{ receiveCompanyName }}</p>
          </li>
          <li>
            <p class="li-label">出库日期：</p>
            <p class="li-name">{{ actionDate }}</p>
          </li>
        </ul>
      </div>
      <van-popup v-model="show">
        <div class="cert-box">
          <div class="cert-con">
            <div class="cert-title">产品合格证</div>
            <div class="cert-info">
              <div class="cert-li">执行标准：详见外包装</div>
              <div class="cert-li">检验结论：合格</div>
              <div class="cert-li">生产日期/批号：{{ batchNum }}</div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"
import { scanCode, scanCodePreview, getWxConfig } from "@/common/api.js"
import province from "@/common/province.json"
import wx from "weixin-js-sdk"
import QRCode from "qrcodejs2"
import { selectPackage } from "../common/api"
import { Button, Dialog } from "vant"
import { data } from "jquery"
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Button.name]: Button,
  },
  data() {
    return {
      fromStatus: true,
      code: "",
      ishave: true,
      loading: true,
      provCode: "",
      cityCode: "",
      areaCode: "",
      message: "",
      params: {
        tracecodeScanLog: {
          provCode: "",
          cityCode: "",
          areaCode: "",
        },
        type: "0",
      },
      showGetLocation: false,
      strAll: "",
      scanCodeInfo: "",
      count: null, //扫码次数
      firstScanDate: "", //首次扫码时间
      productName: "", //产品名称
      specifications: "", //净含量
      edibleMethod: "",
      productImg: "",
      productVideoPoster: "",
      playerOptions: {
        muted: true,
        language: "zh-CN",
        aspectRatio: "16:9",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm",
          },
        ],
        poster: "/static/images/author.jpg",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      batchNum: "", //生产批号
      show: false, //显示合格证
      receiveCompanyName: "", //经销商
      actionDate: "", //生产日期
    }
  },
  computed: { ...mapState(["codeInfo"]) },
  created() {},
  mounted() {
    // if (window.location.hostname == "47.108.212.101") {
    //   window.location.href =
    //     "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI5MzMwMTYwOA==#wechat_redirect";
    //   return;
    // }
    ;(function (win, lib) {
      var doc = win.document
      var docEl = doc.documentElement
      var metaEl = doc.querySelector('meta[name="viewport"]')
      var flexibleEl = doc.querySelector('meta[name="flexible"]')
      var dpr = 0
      var scale = 0
      var tid
      var flexible = lib.flexible || (lib.flexible = {})

      if (metaEl) {
        console.warn("将根据已有的meta标签来设置缩放比例")
        var match = metaEl.getAttribute("content").match(/initial\-scale=([\d\.]+)/)
        if (match) {
          scale = parseFloat(match[1])
          dpr = parseInt(1 / scale)
        }
      } else if (flexibleEl) {
        var content = flexibleEl.getAttribute("content")
        if (content) {
          var initialDpr = content.match(/initial\-dpr=([\d\.]+)/)
          var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/)
          if (initialDpr) {
            dpr = parseFloat(initialDpr[1])
            scale = parseFloat((1 / dpr).toFixed(2))
          }
          if (maximumDpr) {
            dpr = parseFloat(maximumDpr[1])
            scale = parseFloat((1 / dpr).toFixed(2))
          }
        }
      }

      if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi)
        var isIPhone = win.navigator.appVersion.match(/iphone/gi)
        var devicePixelRatio = win.devicePixelRatio
        if (isIPhone) {
          // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
          if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
            dpr = 3
          } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
            dpr = 2
          } else {
            dpr = 1
          }
        } else {
          // 其他设备下，仍旧使用1倍的方案
          dpr = 1
        }
        scale = 1 / dpr
      }

      docEl.setAttribute("data-dpr", dpr)
      if (!metaEl) {
        metaEl = doc.createElement("meta")
        metaEl.setAttribute("name", "viewport")
        metaEl.setAttribute(
          "content",
          "initial-scale=" + scale + ", maximum-scale=" + scale + ", minimum-scale=" + scale + ", user-scalable=no"
        )
        if (docEl.firstElementChild) {
          docEl.firstElementChild.appendChild(metaEl)
        } else {
          var wrap = doc.createElement("div")
          wrap.appendChild(metaEl)
          doc.write(wrap.innerHTML)
        }
      }

      function refreshRem() {
        var width = docEl.getBoundingClientRect().width
        if (width / dpr > 540) {
          width = 540 * dpr
        }
        var rem = width / 10
        docEl.style.fontSize = rem + "px"
        flexible.rem = win.rem = rem
      }

      win.addEventListener(
        "resize",
        function () {
          clearTimeout(tid)
          tid = setTimeout(refreshRem, 300)
        },
        false
      )
      win.addEventListener(
        "pageshow",
        function (e) {
          if (e.persisted) {
            clearTimeout(tid)
            tid = setTimeout(refreshRem, 300)
          }
        },
        false
      )

      if (doc.readyState === "complete") {
        doc.body.style.fontSize = 12 * dpr + "px"
      } else {
        doc.addEventListener(
          "DOMContentLoaded",
          function (e) {
            doc.body.style.fontSize = 12 * dpr + "px"
          },
          false
        )
      }
      refreshRem()
      flexible.dpr = win.dpr = dpr
      flexible.refreshRem = refreshRem
      flexible.rem2px = function (d) {
        var val = parseFloat(d) * this.rem
        if (typeof d === "string" && d.match(/rem$/)) {
          val += "px"
        }
        return val
      }
      flexible.px2rem = function (d) {
        var val = parseFloat(d) / this.rem
        if (typeof d === "string" && d.match(/px$/)) {
          val += "rem"
        }
        return val
      }
    })(window, window["lib"] || (window["lib"] = {}))
    this.getLocation();
    this.loading = true
    // this.getcodeinfo()
  },
  methods: {
    getVideoBase64(url) {
      console.log("getVideoBase64", url)
      let that = this
      return new Promise(function (resolve, reject) {
        var dataURL = ""
        const video = document.createElement("video")
        video.setAttribute("crossOrigin", "anonymous") //处理跨域
        video.setAttribute("src", url)
        video.setAttribute("width", 400)
        video.setAttribute("height", 400)
        video.setAttribute("preload", "auto") // 就是加上预加载之后绘制就成功了
        // document.body.append(video);
        video.addEventListener("loadeddata", function () {
          var canvas = document.createElement("canvas"),
            width = video.width, //canvas的尺寸和图片一样
            height = video.height
          canvas.width = width
          canvas.height = height
          canvas.getContext("2d").drawImage(video, 0, 0, width, height) //绘制canvas
          dataURL = canvas.toDataURL("image/jpeg") //转换为base64
          resolve(dataURL)
          // document.body.append(canvas);
        })
      })
    },

    getLocation() {
      const self = this
      var useragent = navigator.userAgent
      console.log(useragent)
      if (useragent.match(/MicroMessenger/i) != "MicroMessenger") {
        // 这里警告框会阻塞当前页面继续加载
        // alert("已禁止本次访问：您必须使用微信内置浏览器访问本页面！");
        // 以下代码是用javascript强行关闭当前页面
        // var opened = window.open("about:blank", "_self");
        // opened.opener = null;
        // opened.close();
        AMap.plugin("AMap.Geolocation", function () {
          var geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000, //超过10秒后停止定位，默认：5s
            position: "RB", //定位按钮的停靠位置
            offset: [10, 20], //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
            zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
          })
          geolocation.getCurrentPosition(function (status, result) {
            console.log(JSON.stringify(result))
            if (status == "complete") {
              onComplete(result)
            } else {
              onError(result)
            }
          })
        })
        //解析定位结果
        function onComplete(data) {
          console.log(JSON.stringify(data))
          let latitude = data.position.lat
          let longitude = data.position.lng
          let geocoder
          AMap.plugin("AMap.Geocoder", function () {
            geocoder = new AMap.Geocoder({
              city: "010", //城市设为北京，默认：“全国”
              radius: 1000, //范围，默认：500
            })
            let lnglat = [longitude, latitude]
            geocoder.getAddress(lnglat, function (status, result) {
              console.log(JSON.stringify(result))
              if (status === "complete" && result.regeocode) {
                let adCode = result.regeocode.addressComponent.adcode
                self.getCodeArray(adCode)
                self.getcodeinfo()
              } else {
                console.log("根据经纬度查询地址失败")
                self.getcodeinfo()
              }
            })
          })
        }
        //解析定位错误信息
        function onError(data) {
          AMap.plugin("AMap.CitySearch", function () {
            var citySearch = new AMap.CitySearch()
            citySearch.getLocalCity(function (status, result) {
              if (status === "complete" && result.info === "OK") {
                // 查询成功，result即为当前所在城市信息
                console.log(result)
                AMap.plugin("AMap.Geocoder", function () {
                  let geocoder = new AMap.Geocoder({
                    // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                    city: result.adcode,
                  })
                  var lnglat = result.rectangle.split(";")[0].split(",")
                  geocoder.getAddress(lnglat, function (status, data) {
                    if (status === "complete" && data.info === "OK") {
                      let adCode = data.regeocode.addressComponent.adcode
                      self.getCodeArray(adCode)
                      self.getcodeinfo()
                    } else {
                      self.getcodeinfo()
                    }
                  })
                })
              } else {
                self.getcodeinfo()
              }
            })
          })
        }
      } else {
        // alert("已通过本次访问：您必须使用微信内置浏览器访问本页面！");
        var test = window.location.href
        getWxConfig({ url: test }).then((res) => {
          console.log(res)
          wx.config({
            // debug: true,
            appId: res.appid, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonce, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["openLocation,getLocation"], // 必填，需要使用的JS接口列表 例如（获取地理位置）
          })
          wx.ready(function () {
            wx.getLocation({
              type: "wgs84", // 默认为wgs84的 gps 坐标，如果要返回直接给 openLocation 用的火星坐标，可传入'gcj02'
              success: function (res) {
                let latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
                let longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
                AMap.plugin("AMap.Geocoder", function () {
                  let geocoder = new AMap.Geocoder({
                    // city: "010", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                  })
                  // let lnglat = [117.40665, 36.743916];
                  let lnglat = [longitude, latitude]
                  geocoder.getAddress(lnglat, function (status, result) {
                    console.log(result)
                    if (status === "complete" && result.regeocode) {
                      let adCode = result.regeocode.addressComponent.adcode
                      self.getCodeArray(adCode)
                      self.getcodeinfo()
                    } else {
                      console.log("根据经纬度查询地址失败")
                      self.getcodeinfo()
                    }
                  })
                })
              },
              fail: function () {
                // alert(JSON.stringify(data));
                // if (
                //   data.originMessage &&
                //   data.originMessage == "User denied Geolocation"
                // ) {
                //   Dialog.alert({
                //     title: "提示",
                //     message: "开启定位即可参与活动",
                //   }).then(() => {
                //     location.reload();
                //   });
                // }
                self.getcodeinfo()
              },
            })
          })
        })
      }
    },
    certView() {
      this.show = true
    },
    getcodeinfo() {
      // this.loading = false;
      // var url = window.location.href;
      // console.log(url.split('/'))
      // var index = url.lastIndexOf("/");
      // var str = url.substring(index + 1, url.length);
      // str = str.split("?")[0];
      this.code = str
      let url = window.location.pathname
      let urlArr = url.split("/")
      console.log(urlArr)
      let str = urlArr[3]
      this.strAll = urlArr[1] + "/" + urlArr[2] + "/" + urlArr[3]
      scanCode(str, this.params)
        .then((res) => {
          this.loading = false
          this.scanCodeInfo = res
          if (res.errorCode == 200) {
            if (res.tracecodeScanLogVO) {
              this.firstScanDate = res.tracecodeScanLogVO.firstScanDate
              this.count = res.tracecodeScanLogVO.count
            }
            if (res.productionProduct) {
              this.productName = res.productionProduct.productName
              this.edibleMethod = res.productionProduct.edibleMethod
              this.productImg = res.productionProduct.productImg
              this.$nextTick(() => {
                console.log(this.$refs.videoRef)
                if (this.$refs.videoRef) {
                  // this.$refs.videoRef.pause()
                }
                // this.$refs.videoRef.play()
              })
              var resolve = this.getVideoBase64(this.productImg)
              console.log("resolve:", resolve)
              resolve.then((dataURL) => {
                console.log("dataURL:", dataURL)
                this.playerOptions.poster = dataURL
                this.playerOptions.sources = [
                  {
                    type: "video/mp4",
                    src: this.productImg,
                  },
                ]

                // this.productVideoPoster = dataURL
              })
              this.specifications = res.productionProduct.specifications
            }
            if (res.productImportLibrary) {
              this.batchNum = res.productImportLibrary.productBatchNum
            }
            if (res.productExportLibrary) {
              this.receiveCompanyName = res.productExportLibrary.receiveCompanyName || ""
              this.actionDate = res.productExportLibrary.actionDate || ""
            }
          } else {
            this.ishave = false
            this.message = res.msg
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getCodeArray(code) {
      province.forEach((item) => {
        if (item.value == code) {
          this.params.tracecodeScanLog.provCode = item.value
          this.params.tracecodeScanLog.cityCode = ""
          this.params.tracecodeScanLog.areaCode = ""
          return
        } else {
          if (item.children || item.children.length == 0) {
            item.children.forEach((itemCity) => {
              if (itemCity.value == code) {
                this.params.tracecodeScanLog.provCode = item.value
                this.params.tracecodeScanLog.cityCode = itemCity.value
                this.params.tracecodeScanLog.areaCode = ""
                return
              } else {
                if (itemCity.children || itemCity.children.length == 0) {
                  itemCity.children.forEach((itemDic) => {
                    if (itemDic.value == code) {
                      this.params.tracecodeScanLog.provCode = item.value
                      this.params.tracecodeScanLog.cityCode = itemCity.value
                      this.params.tracecodeScanLog.areaCode = itemDic.value
                      return
                    }
                  })
                }
              }
            })
          }
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
@base: 40;

.wrapper {
  html {
    font-size: 20px;
  }

  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;

  .nohave {
    padding: 0 1rem / @base * 15;
    margin-top: 200px;

    .info {
      margin-top: 1rem / @base * 20;

      // display: flex;
      .image {
        width: 40%;
        text-align: center;
        margin: 0 auto;

        // height: 1rem;
        img {
          width: 100%;
          height: auto;
        }
      }

      .code {
        margin-top: 30px;
        text-align: center;

        p {
          color: red;
          font-size: 1rem / @base * 16;
        }

        .line {
          width: 100%;
          height: 1px;
          border: 1px solid #eee;
        }

        .tishi {
          margin-top: 10px;
          color: royalblue;
          font-size: 1rem / @base * 16;
        }
      }
    }
  }

  .content-logo {
    width: 100%;

    img {
      width: 100%;
      height: auto;
      display: block;
    }

    .company-name {
      font-size: 1rem / @base * 16;
      text-align: center;
      width: 80%;
      margin: 0 auto;
      color: #b0823b;
    }
  }

  .common-box {
    width: calc(95% - 20px);
    padding: 20px 10px;
    background-color: #d3a100;
    border-radius: 10px;
    font-size: 0.42rem;
    color: #f5f5f5;
    .flex-column {
      display: flex;
      flex-direction: column;
      gap: 10px;
      .li-name {
        width: auto;
        background: #fff;
        color: #000;
      }
    }
  }

  .search-info {
    margin: 10px auto 0;

    .search-num {
      letter-spacing: 2px;
    }

    .search-date {
      color: #fff;
      padding: 15px 0;
      font-weight: bold;
      font-size: 0.5rem;
    }

    .search-company {
      line-height: 1.5;
      letter-spacing: 2px;
    }
  }

  .tracecode-box {
    margin: 10px auto;
  }

  .flow-name {
    font-size: 1rem / @base * 16;
    font-weight: bold;
    text-indent: 10px;
    padding: 10px 0;
  }

  .content-details {
    margin: 10px auto;
    padding: 10px;

    ul {
      width: 92%;
      margin: 0 auto;

      li {
        display: flex;
        width: 100%;
        padding: 8px 0;

        .li-label {
          // width: 80px;
          font-size: 0.42rem;
          flex-shrink: 0;
        }

        .li-name {
          width: calc(100% - 100px);
          font-size: 0.42rem;
          word-break: break-word;
        }
      }
    }

    .video {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
      width: 100%;
      height: 100%;

      /deep/.video-palyer-box {
        width: 100%;
        height: 100%;

        & .video-js {
          width: 100%;
        }

        .vjs-poster {
          width: 100%;
          height: 100%;
        }

        .vjs-big-play-button {
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .li-label {
      }

      .li-name {
        width: 100%;
        height: 100%;
      }
    }

    .test {
      display: flex;
      flex-direction: column;
      row-gap: 8px;

      .li-name {
        width: 100%;
        text-indent: 2em;
      }
    }
  }

  .content {
    margin-top: 8rem / @base;

    .logo {
      width: 100%;
      text-align: center;
      background-color: #fff;

      img {
        width: 50%;
      }
    }

    .info {
      margin-top: 8rem / @base;
      background-color: #fff;
      padding-left: 35rem / @base;

      .l1 {
        padding: 20rem / @base 0 0;
        display: flex;
        align-items: baseline;

        &:last-child {
          padding-bottom: 20rem / @base;
        }

        span {
          color: #343434;
          font-size: 1rem / @base * 16;
        }

        .s1 {
          width: 31%;
          text-align: left;
        }

        .btn {
          width: 150rem / @base;
          height: 50rem / @base;
          background-image: url("../image/scan/btnbg.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          text-align: center;
          color: #fff;
          line-height: 40rem / @base;
        }
      }
    }

    .productInfo {
      margin-top: 8rem / @base;
      background-color: #fff;
      padding: 0 30rem / @base 0 30rem / @base;

      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12rem / @base 0;
        border-bottom: 1px solid #f1f1f1;
        font-size: 1rem / @base * 15 !important;

        .left {
          display: flex;
          align-items: center;

          .line {
            height: 30rem / @base;
            width: 5rem / @base;
            background-color: #1375d2;
            margin-right: 6rem / @base;
          }

          .text {
            font-size: 1rem / @base * 18;
          }
        }

        .right {
          img {
            width: 20rem / @base;
            height: 20rem / @base;
            transform: rotate(0deg);
            transition: transform 0.5s;
          }

          .active {
            transform: rotate(180deg);
            transition: transform 0.5s;
          }
        }
      }

      .box {
        .companyInfo {
          line-height: 1rem / @base * 24;
          padding: 10rem / @base 0;
        }

        .l1 {
          padding: 20rem / @base 0 0;
          display: flex;
          align-items: baseline;

          &:last-child {
            padding-bottom: 20rem / @base;
          }

          span {
            color: #343434;
            font-size: 1rem / @base * 16;
          }

          .s1 {
            width: 31%;
            text-align: left;
          }

          .index {
            width: 100%;
            font-size: 1rem / @base * 18;
            font-weight: bold;
            color: #1375d2;
            border-bottom: 1px solid #f1f1f1;
            padding: 15rem / @base 0;
          }

          .activeIndex {
            border-top: 1px solid #f1f1f1;
          }
        }

        .textwrap {
          .image {
            width: 60%;
            display: block;
            margin: 20rem / @base auto;
          }

          .text {
            line-height: 1rem / @base * 24;
            text-indent: 2em;
            padding-bottom: 10rem / @base;
            font-size: 1rem / @base * 15 !important;
          }
        }
      }
    }
  }

  .cert-box {
    height: 28rem / @base * 8;
    width: 40rem / @base * 8;

    .cert-con {
      width: 80%;
      height: 80%;
      margin: calc(16%) calc(10% - 3px) calc(10% - 3px);
      border: solid 3px #9e9f9f;
      border-radius: 10px;
      position: relative;

      .cert-title {
        font-size: 21rem / @base;
        font-weight: bold;
        height: 20rem / @base * 2;
        background-color: #009944;
        border-radius: 20rem / @base;
        width: 40rem / @base * 4;
        color: #ffffff;
        line-height: 20rem / @base * 2;
        text-align: center;
        position: absolute;
        left: 50%;
        top: -20rem / @base;
        transform: translateX(-50%);
      }

      .cert-info {
        margin-top: 20rem / @base * 2;

        .cert-li {
          margin-top: 10rem / @base * 2;
          font-size: 16rem / @base;
          width: 90%;
          margin-left: 5%;
          padding-bottom: 5px;
          border-bottom: 2px solid #9e9f9f;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/scanIndex.vue